<template>
  <div class="orderComp">
    <div class="toolbar">
      <button-comp class="btn_download tool_item" :classBtn="'btn_orange_min'" :textBtn="'Скачать чек'" :clickBtn="downloadOrderDoc"/>
    </div>
    <tbl-one-comp :rows="orderTbl"/>
  </div>
</template>

<script>
export default {
  name: 'orderComp',
  props: {
  },
  data: function () {
    return {
      moduleName: 'orders',
      required: ['id', 'createdAt', 'updatedAt', 'bonus', 'command', 'countMinutes', 'dealerIdMysql', 'info', 'kontrollerIdMysql', 'payType', 'pointName', 'price', 'sberOrderId', 'status']
    }
  },
  created: function () {
    this.$store.dispatch(`${this.moduleName}/getOne`, { required: null })
  },
  components: {
  },
  computed: {
    orderFull: function () { return this.$store.getters[`${this.moduleName}/getOne`] },
    orderTbl: function () {
      let model = this.$store.getters[`${this.moduleName}/getOne`]
      return this.$helpers.mapper.modelRequired(this.required, model)
    }
  },
  methods: {
    toAll () {
      this.$store.dispatch(`${this.moduleName}/toAll`)
    },
    downloadOrderDoc () {
      let orderUrl = this.orderFull.urlOrderDoc.value
      if (!orderUrl.startsWith('/')) orderUrl = '/' + orderUrl
      let url = `${this.$http.server_api_url}${orderUrl}`
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped lang="scss">

.orderComp {
  display: grid;
  grid-template-rows: 116px 1fr 116px;
  grid-template-columns: 1fr;
  width: 100%;
  min-width: 320px;
}
.toolbar {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr auto;
}
.tool_item {
  height: 36px;
  margin: 40px 32px 40px auto;
}
.btn_download {
  width: 150px;
}

</style>
